import { Box, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import theme from '../../../../../../config/theme';

export default function CodeInfoBox() {
  return (
    <Box
      sx={{
        background: theme.palette.primary.dark,
        borderRadius: '5px',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        height: '58px',
        px: '44px',
        width: 'fit-content',
        whiteSpace: 'pre-line',
      }}
    >
      <Typography variant="body1" color={theme.palette.primary.contrastText}>
        <Trans
          i18nKey="mediaPlanning.playgroundInfoBox"
          components={{ bold: <strong /> }}
        />
      </Typography>
    </Box>
  );
}
